import styled from "styled-components/macro";
import { rem } from "polished";

import { BREAKPOINT_WRAPPER } from "../../constants";
import { colors, fonts } from "../../styles/Styles.variables";

import { Link } from "react-router-dom";

import Button from "./Button";
import Form from "../../modules/form";

export const AuthForm = styled(Form)`
  padding-top: ${rem("32px")};
`;

export const AuthFormHeader = styled.header`
  text-align: center;

  h1 {
    font-weight: ${fonts.weights.normal};
    line-height: 1;
    margin: 0 0 ${rem("10px")};
    padding-top: ${rem("10px")};
  }

  p {
    line-height: 1.4;

    &.success {
      margin-bottom: ${rem("28px")};
    }
  }
`;

export const AuthFormButton = styled(Button).attrs(props => ({
  color: "yellow",
  type: "submit",
}))`
  display: block;
  margin: 0 auto;
  width: 100%;

  @media ${BREAKPOINT_WRAPPER} {
    width: auto;
    padding-left: ${rem("62px")};
    padding-right: ${rem("62px")};
  }
`;

export const AuthFormActions = styled.div`
  padding-bottom: ${rem("26px")};
  padding-top: ${rem("20px")};
`;

export const AuthFormLink = styled(Link)`
  color: ${colors.gray600};
  display: block;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
`;
